<template>
    <div>
        <div class="uk-padding">
            <div class="uk-container">
                <h1 class="uk-text-center">College of Humanities, Social Sciences & Behavioural Sciences</h1>
                <hr>
                <h2 class="uk-text-left" >Message from the Dean
                    <span class="uk-text-muted uk-text-small uk-text-italic" style="font-variant: none !important;"> Vincent M. S. Peterkin, PhD</span>
                </h2>
                <div class="uk-panel">

                    <img class="uk-border-pill uk-align-left@m" src="../assets/vincentpeterkin.png" width="150" height="150" alt="Border pill">

                    <p>
                        Welcome to the College of Humanities, Behavioural and Social Sciences (HUBSS); your
                        college, your campus, and your home away from home. It is both an honour and a privilege to
                        welcome you to this amazing family community and healthy productive learning
                        environment. There is no doubt you have made the right choice and thank you for making the
                        sacrifice to be here. You are here because you deserve to be, and because you can bring
                        something new and exciting to this active learning community.
                    </p>
                    <p>
                        HUBSS brings to you the experience of transformation, community, and development. Most,
                        if not all, of you know exactly what you want to study and plan to remain focused on your
                        avocation. Each department, guided by the Chair/Coordinator, teachers, and student advisors,
                        is equipped to facilitate your personal goals and ambition as you wend your way through the
                        corridors and learning spaces in our college. I encourage you to be open to new ideas,
                        experiences, and directions as you seek to foster a spirit of independence and self-direction
                        through carefully articulated self-advocacy. You will be learning in this Christian community
                        from the crème de la crème in your chosen academic discipline, and with young, brilliant
                        minds surrounding you, will be challenged to think creatively and critically.
                    </p>
                    <p>
                        The grace of God is sufficient for you! May His blessings and presence attend you as you
                        sojourn here with us and make good your academic stewardship. It can be done! Yes, you
                        can! Welcome home!
                    </p>

                    <p>


                        Sincerely <br>
                        Vincent M. S. Peterkin, PhD<br>
                        Acting Dean of the College of Humanities, Behavioural & Social Sciences
                    </p>
                </div>
            </div>
        </div>
        <hubbs-department-links/>
        <div class="uk-padding ">
            <div class="uk-container uk-container-large">
                <h3 class="uk-heading-bullet">Get in touch with us</h3>
                <div class="uk-child-width-1-3@m" uk-grid>
                    <div>
                        <div class="uk-card uk-card-hover uk-card-body">

                            <dl class="uk-description-list">
                                <dt class="uk-text-capitalize">Name: Vincent Peterkin (Dean) </dt>
                                <dd>
                                    <ul class="uk-list uk-list-divider">
                                        <li>Phone: <span class="uk-text-small"> Internal:</span> <span class="uk-text-bold">7173</span>
                                            <br>
                                            <span class="uk-text-small"> External:</span> <span class="uk-text-bold">1-876-963-7173</span></li>
                                    </ul>
                                </dd>

                            </dl>
                        </div>
                    </div>
                    <div>
                        <div class="uk-card uk-card-hover uk-card-body">

                            <dl class="uk-description-list">
                                <dt class="uk-text-capitalize">Name: Sandra Lawe (Administrative Asst)  </dt>
                                <dd>
                                    <ul class="uk-list uk-list-divider">
                                        <li>Phone: <span class="uk-text-small"> Internal:</span> <span class="uk-text-bold">7497</span>
                                            <br>
                                            <span class="uk-text-small"> External:</span> <span class="uk-text-bold">1-876-963-7497</span></li>
                                    </ul>
                                </dd>

                            </dl>
                        </div>
                    </div>

                </div>
            </div>



        </div>
    </div>
</template>

<script>
    import HubbsDepartmentLinks from "../components/colleges/hubbs/departmentLinks";
    export default {
        name: "hubbs",
        components: {HubbsDepartmentLinks}
    }
</script>

<style scoped>

</style>